import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import DischargePlanningSvc from "@/services/dischargePlanningService";

@Module({ store, dynamic: true, namespaced: true, name: "discharge-planning" })
class DischargePlanningModule extends VuexModule {
  currentItem: any = null;
  registerId: string | number | null = null;
  loading = false;

  @Mutation SET_CURRENT_ITEM(val: any) {
    this.currentItem = val;
  }

  @Mutation SET_REGISTER(val: string | number | null) {
    this.registerId = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async fetchByRegister(reg: string | number) {
    if (String(this.registerId) !== String(reg)) {
      this.SET_CURRENT_ITEM(null);
    }

    this.SET_REGISTER(reg);
    this.SET_LOADING(true);

    try {
      const dt = await DischargePlanningSvc.getByRegister(reg);
      const { data } = dt.data;

      if (String(this.registerId) === String(reg)) {
        this.SET_CURRENT_ITEM(data || null);
      }
    } catch {
      if (String(this.registerId) === String(reg)) {
        this.SET_CURRENT_ITEM(null);
      }
    }

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_CURRENT_ITEM(null);
    this.SET_REGISTER(null);
  }
}

export const storeDischargePlanning = getModule(DischargePlanningModule);
